export const PRODUCTS_FETCH_END = "setProductTable";
export const EAGER_PRODUCTS_FETCH_END = "setProductTableEager";
export const PRODUCTS_FETCH_START = "setLoading";
export const CATEGORY_CHANGED = "categoryChanged";
export const NO_RESPONSE_ERROR = "noResponseError";
export const COMPARE_NO_RESPONSE_ERROR = "compareNoResponseError";
export const COMPARE_FETCH_START = "compareFetchStart";
export const COMPARE_FETCH_END = "compareFetchEnd";
export const FILE_DOWNLOADED = "fileDownloaded";
export const RECOMMENDED_FETCH_START= "recommendedFetchStart";
export const RECOMMENDED_FETCH_END = "recommendedFetchEnd";
export const COMPARE_FILE_DOWNLOADED = "compareFileDownloaded";
export const RECOMMENDED_FILE_DOWNLOADED = "recommendedFileDownloaded";
export const QUERY_CHANGED = "queryChanged";
export const CATEGORIES_FETCHED = "categoriesFetched";
export const DOCUMENTS_FETCHED = "documentsFetched";
export const USER_TASKS_FETCHED = "userTasksFetched";
export const NO_ITEMS_FOUND = "noItemsFound";
export const REFRESH_MODAL = "refreshModal";
export const PERMISSIONS_FETCHED = "permissionsFetched";
export const PERMISSION_CHANGED = "permissionChanged";
export const PRODUCTS_FETCHED = "productsFetched";
export const PRODUCTS_CHANGED = "productsChanged";
export const COMMENT_CHANGED = "commentChanged";
export const FETCHED_MY_SUPPORT_CONTACT = "fetchedMySupportContact";
export const FETCHED_MY_SUPPORT_TOPICS = "fetchedMySupportTopics";
export const REFRESH_USER = "refreshUser";
export const REMOVE_USER = "removeUser";

// Generic mutations
export const ASYNC_ACTION_START = "asyncActionStart";
export const ASYNC_ACTION_END = "asyncActionEnd";
export const ASYNC_ACTION_DONE = "asyncActionDone";
export const RESET_STATE = "resetModuleState";
